module.exports = __webpack_public_path__ + "img/3c.cc80502a.svg";